import models from "../../model/models";
import history from "../../history";
import toasts from "../../utils/toasts";
import Popup from "../../components/popup/Popup";
import DeleteConfirmationPopup from "../../components/deleteConfirmationPopup/DeleteConfirmationPopup";
import Card from "../../components/card/Card";
import Label from "../../components/label/Label";
import Input from "../../inputs/input/Input";
import UniversalDropDown from "../../components/universalDropDown/UniversalDropDown";
import Button from "../../components/button/Button";
import React, {Component} from "react";
import './UpdateUnitPopup.css';

export default class UpdateUnitPopup extends Component {
	constructor(props) {
		super(props);
		this.myRefs = {};
		this.state = {};
	}

	_close = () => {
		this.props.onClose();
	};

	_save = async () => {
		let unit = this.getValue();
		unit.id = this.props.id;
		this._close();
		await models.unit.save(unit);
	};

	getValue = () => {
		let obj = {};
		for (let i in this.myRefs) {
			obj[i] = this.myRefs[i].getValue();
		}
		return obj;
	};

	_showArchivePopup = () => {
		this.setState({ showArchive: true });
	};

	_closeArchivePopup = () => {
		this.setState({ showArchive: false });
	};

	_archiveUnit = async () => {
		const {archived, reason} = await models.unit.archive(this.props.id);
		if (archived) {
			this._close();
			history.navigate('/units');
		}
		else if (reason === 'UNRESOLVED_DEPENDENCY') {
			toasts.show('Can not archive unit. Transfer or archive all boxes assigned to this unit.', 5000);
		}
		else {
			toasts.show('Could not archive unit.');
		}
	};

	render() {
		return (
			<Popup show={true} onClose={this._close} className={'g-update-unit-popup'}>
				<DeleteConfirmationPopup
					show={this.state.showArchive}
					confirmation={`Are you sure you want to archive this unit?`}
					title={'Archive'}
					name="unit"
					onClose={this._closeArchivePopup}
					onConfirm={this._archiveUnit}
				/>
				<Card>
					<Label large black>
						Edit Unit
					</Label>
					<div className="content">
						<div>
							<Label black>Name</Label>
							<Input length={15} value={this.props.name} ref={(ref) => (this.myRefs.name = ref)} />
						</div>
						{Boolean(models.user_group.obj().enable_knox_integration) &&
							<div>
								<Label black>Knox MedVault Serial Number</Label>
								<Input value={this.props.knox_box_serial_number}
											 ref={(ref) => (this.myRefs.knox_box_serial_number = ref)}/>
							</div>
						}
						<div>
							<Label black>Location</Label>
							<Input value={this.props.location} className="location" ref={(ref) => (this.myRefs.location = ref)} />
						</div>
						<div>
							<Label black>Type</Label>
							<UniversalDropDown
								value={this.props.type}
								className="type"
								ref={(ref) => (this.myRefs.type = ref)}
								options={{ deployed: 'Deployed', supply: 'Supply' }}
							/>
						</div>
						<div className="button-row">
							<Button color="white" bg="red" onClick={this._showArchivePopup}>Archive</Button>
							<Button color="white" bg="blue" onClick={this._save}>
								Save
							</Button>
						</div>
					</div>

				</Card>
			</Popup>
		);
	}
}


// WEBPACK FOOTER //
// ./src/popups/updateUnitPopup/UpdateUnitPopup.jsx